import { render, staticRenderFns } from "./UserProfileSettings.vue?vue&type=template&id=38f0ca62&"
import script from "./UserProfileSettings.vue?vue&type=script&lang=js&"
export * from "./UserProfileSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports